module.exports = __webpack_public_path__ + "static/img/bg1.894440e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw/bg1.png
// module id = KN2m
// module chunks = 1